/* unplugin-vue-components disabled */import { render } from "./CuaLoading.vue?vue&type=template&id=10af2668&scoped=true"
import script from "./CuaLoading.vue?vue&type=script&lang=js"
export * from "./CuaLoading.vue?vue&type=script&lang=js"

import "./CuaLoading.vue?vue&type=style&index=0&id=10af2668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10af2668"]])

export default __exports__